module.exports = __webpack_public_path__ + "static/img/slider-2.0c825b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg/slider-2.jpg
// module id = HqNB
// module chunks = 9